import { render, staticRenderFns } from "./v-plastic-section.vue?vue&type=template&id=493b0710&"
import script from "./v-plastic-section.vue?vue&type=script&lang=js&"
export * from "./v-plastic-section.vue?vue&type=script&lang=js&"
import style0 from "./v-plastic-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports